export const LOYALTY_REWARDS = "Loyalty Rewards";

export const SILVER = "Silver";
export const GOLD = "Gold";
export const PLATINUM = "Platinum";
export const FOUNDER_CLUB = "Founder Club";

export const HEADER = "Start Earning Points";

export const HOME_ACCORDIAN = [
  {
    summary: "How do I earn points? ",
    content:
      "You earn points by making eligible purchases, engaging with our services, or participating in promotions. Specific details on how points are accumulated can be found in the program terms.",
  },
  {
    summary: "Are there limitations on how many points I can earn? ",
    content:
      "There may be caps on the number of points you can earn within a specific time period. Check the program’s rules for any limitations.",
  },
  {
    summary: "Do my points expire",
    content:
      "Yes, points typically have an expiration period. Be sure to redeem your points before they expire, as specified in the program terms.",
  },
];

export const stepItems = [
  { title: "Reward", description: "Select your reward" },
  { title: "Timeline", description: "Choose duration" },
  { title: "Points", description: "Review points" },
  { title: "Activities", description: "Choose activities" },
];

export const NEW_PROJECT_ACCESS_KEY = "7178NMROB17611937949776"
